<template>
  <Card variant="primary" :shadow="true">
    <template #header>
      <Text variant="h1">Performance</Text>
      <LoadingIndicator v-if="isLoading" />
    </template>

    <View gap="lg" direction="column">
      <Statistics
        v-model="selectedConfigName"
        :data="statisticsData"
        :status="statisticsQuery.status.value"
        :loading="statisticsQuery.isLoading.value"
        @retry="statisticsQuery.refetch()"
      />
      <div class="filters">
        <TopBarFilters :filters="filters" :selectedFilter="selectedFilter" @selected="selectedFilter = $event" />
      </div>
      <div class="chart">
        <Chart
          v-if="timeSeriesQuery.status.value === 'success' && timeSeriesData"
          :config-name="selectedConfigName"
          :time-series-data="timeSeriesData"
        />
        <View v-else-if="timeSeriesQuery.status.value === 'error'" justify="center" align="center" class="chart-state">
          <InlineError
            message="Couldn't load the performance chart."
            :loading="timeSeriesQuery.isLoading.value"
            @retry="timeSeriesQuery.refetch()"
          />
        </View>
        <View v-else justify="center" align="center" class="chart-state">
          <LoadingIndicator />
        </View>
      </div>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Card, LoadingIndicator, Text, TopBarFilters, View } from '@tallo/design-system';
import {
  PortfolioStatisticsFilter,
  usePortfolioStatisticsQuery,
  usePortfolioTimeSeriesQuery,
} from '@tallo/investor/portfolio-statistics';

import InlineError from './inline-error.vue';
import Chart from './performance/chart.vue';
import { StatisticsConfigName } from './performance/statistics-config';
import Statistics from './performance/statistics.vue';

const filters = Object.values(PortfolioStatisticsFilter);
const selectedConfigName = ref(StatisticsConfigName.LEADS);
const selectedFilter = ref(filters[0]);
const timeSeriesQuery = usePortfolioTimeSeriesQuery(selectedFilter);
const timeSeriesData = computed(() => timeSeriesQuery.data.value || undefined);
const statisticsQuery = usePortfolioStatisticsQuery(selectedFilter);
const statisticsData = computed(() => statisticsQuery.data.value || undefined);
const isLoading = computed(() => timeSeriesQuery.isPending.value || statisticsQuery.isPending.value);
</script>

<style scoped lang="scss">
.chart {
  width: 100%;
  height: 14rem;
}

.chart-state {
  width: 100%;
  height: 100%;
}
</style>
